import type { PropCategory } from "@circle-react-shared/BuilderUI/DataModel.types";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { DesignProp } from "@circle-react-shared/BuilderUI/constants/PropCategories";

export const getObjectFitOptions = ({
  defaultValue = "cover",
  category = [DesignProp],
}: {
  defaultValue?: string;
  category?: PropCategory[];
}): StyleValue => ({
  type: "select",
  value: defaultValue,
  meta: {
    name: "Object fit",
    nameI18n: "builder_ui.prop_type.styles.object_fit",
    category,
    options: [
      {
        label: "Cover",
        labelI18n: "builder_ui.prop_type.styles.object_fit_types.cover",
        value: "cover",
      },
      {
        label: "Contain",
        labelI18n: "builder_ui.prop_type.styles.object_fit_types.contain",
        value: "contain",
      },
      {
        label: "Fill",
        labelI18n: "builder_ui.prop_type.styles.object_fit_types.fill",
        value: "fill",
      },
      {
        label: "None",
        labelI18n: "builder_ui.prop_type.styles.object_fit_types.none",
        value: "none",
      },
    ],
  },
});

export const getObjectPositionOptions = ({
  defaultValue = "center",
  category = [DesignProp],
}: {
  defaultValue?: string;
  category?: PropCategory[];
}): StyleValue => ({
  type: "select",
  value: defaultValue,
  meta: {
    name: "Object position",
    nameI18n: "builder_ui.prop_type.styles.object_position",
    category,
    options: [
      {
        label: "Center",
        labelI18n: "builder_ui.prop_type.styles.object_position_types.center",
        value: "center",
      },
      {
        label: "Top",
        labelI18n: "builder_ui.prop_type.styles.object_position_types.top",
        value: "top",
      },
      {
        label: "Bottom",
        labelI18n: "builder_ui.prop_type.styles.object_position_types.bottom",
        value: "bottom",
      },
      {
        label: "Left",
        labelI18n: "builder_ui.prop_type.styles.object_position_types.left",
        value: "left",
      },
      {
        label: "Right",
        labelI18n: "builder_ui.prop_type.styles.object_position_types.right",
        value: "right",
      },
    ],
  },
});

export const getImageOpacityOptions = ({
  defaultValue = 1,
  category = [DesignProp],
}: {
  defaultValue?: number;
  category?: PropCategory[];
}): StyleValue => ({
  type: "number",
  value: defaultValue,
  meta: {
    name: "Opacity",
    nameI18n: "builder_ui.prop_type.styles.opacity",
    category,
    numberProps: {
      min: 0,
      max: 1,
      step: 0.1,
    },
  },
});

export const getBorderRadiusOptions = ({
  defaultValue = {
    border_left_top_radius: 2,
    border_left_bottom_radius: 2,
    border_right_top_radius: 2,
    border_right_bottom_radius: 2,
  },
  category = [DesignProp],
}: {
  defaultValue?: {
    border_left_top_radius: number;
    border_left_bottom_radius: number;
    border_right_top_radius: number;
    border_right_bottom_radius: number;
  };
  category?: PropCategory[];
}): StyleValue => ({
  type: "border-radius",
  value: {
    border_left_top_radius: defaultValue.border_left_top_radius,
    border_left_bottom_radius: defaultValue.border_left_bottom_radius,
    border_right_top_radius: defaultValue.border_right_top_radius,
    border_right_bottom_radius: defaultValue.border_right_bottom_radius,
  },
  meta: {
    name: "Corner radius",
    nameI18n: "builder_ui.prop_type.styles.corner_radius",
    unit: "px",
    category,
  },
});
